// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace pageUtil {
    export enum PageTypeEnum {
        noPageType = "no-page-type",
        index = 'index',
        allPosts = 'all-posts',
        postDetail = 'post',
        loadMorePost = 'load-more-post',
        authorPost = 'author-post',
        tag = 'tag',
        astrologyIndex = 'astrology-index',
        astrologyAstrologyHoroscopeReview = 'astrology-horoscope-review',
        breakingNews = 'breaking-news',
        category = 'category',
        authors = 'authors',
        authorArchive = 'author-archive',
        page = 'page',
        election = 'election',
        contract = 'contract',
        financeIndex = 'finance-index',
        financeForex = 'finance-forex',
        financeSubPage = 'finance-subpages',
        sportIndexPage = 'sport-index',
        sportSubPage = 'sport-subpages',
        dynamicPage = 'dynamic-page',
        eNewsPaper = 'enewspaper-page',
        epg = 'epg-page',//electronic program guide page
        program = 'program',
        programList = 'program-list',
        liveStream = 'live-stream'

    }

    export type PageTypeArray = Array<PageTypeEnum>;
}